<mat-toolbar
  class="navbar-container"
  [ngClass]="{
    'navbar-dark-theme': _theme === 'dark-theme',
    'navbar-light-theme': _theme === 'light-theme',
    'navbar-paper-theme': _theme === 'paper-theme',
  }"
>
  <!-- Logo -->
  <ddc-logo
    class="daydic-logo daydic-logo-desktop"
    *ngIf="!_isAdmin"
    routerLinkActive="router-link-active"
    [hasText]="true"
    [routerLink]="'/home'"
    [size]="'medium'"
  ></ddc-logo>
  <ddc-logo
    class="daydic-logo daydic-logo-mobile"
    *ngIf="!_isAdmin"
    routerLinkActive="router-link-active"
    [hasText]="false"
    [routerLink]="'/home'"
    [size]="'medium'"
  ></ddc-logo>
  <!-- subscription & verification icons -->
  <div class="navbar-user-icons">
    @if (_isVerified) {
      <mat-icon class="navbar-status-icon" matTooltip="Verified">verified</mat-icon>
    }
    @if (_subscription === 'Plus') {
      <mat-icon class="navbar-status-icon" matTooltip="Plus">bolt</mat-icon>
    }
    @if (_subscription === 'Pro') {
      <mat-icon class="navbar-status-icon" matTooltip="Pro">diamond</mat-icon>
    }
    @if (_isAdmin) {
      <mat-icon class="navbar-status-icon" matTooltip="Admin">admin_panel_settings</mat-icon>
    }
  </div>
  <!--! Main Buttons -->
  <div class="main-buttons" *ngIf="!_isSignupPage && !_isLoginPage && !_isVerificationPage">
    <!-- Search -->
    <ddc-button-n-one
      class="navbar_search_btn"
      [_hasBorder]="true"
      [_icon]="'search'"
      [_label]="_searchLabel"
      (click)="openSearchDialog()"
    ></ddc-button-n-one>
    <!-- Agents -->
    <!-- <ddc-button-n-one
      class="navbar_agents_btn"
      [_color]="_clickedColorAgents"
      [_dynamicRoute]="'/agents'"
      [_icon]="'face_5'"
      [_label]="'Agents'"
      [_selected]="_isAgentsPage"
    ></ddc-button-n-one> -->
    <!-- Canvas -->
    <ddc-button-n-one
      class="navbar_canvas_btn"
      [_color]="_clickedColorCanvas"
      [_dynamicRoute]="'/canvas'"
      [_icon]="'dashboard'"
      [_label]="'Canvas'"
      [_selected]="_isCanvasPage"
    ></ddc-button-n-one>
    <!-- Library -->
    <ddc-button-n-one
      class="navbar_library_btn"
      [_color]="_clickedColorLibrary"
      [_dynamicRoute]="'/library'"
      [_icon]="'apps'"
      [_label]="'Library'"
      [_selected]="_isLibraryPage"
    ></ddc-button-n-one>
    <!-- Store -->
    <ddc-button-n-one
      class="navbar_store_btn"
      [_color]="_clickedColorStore"
      [_dynamicRoute]="'/store'"
      [_icon]="'explore'"
      [_label]="'Explore'"
      [_selected]="_isStorePage"
    ></ddc-button-n-one>
    <!-- Network -->
    <ddc-button-n-one
      class="navbar_network_btn"
      [_color]="_clickedColorNetwork"
      [_dynamicRoute]="'/network'"
      [_icon]="'people_outline'"
      [_label]="'Network'"
      [_selected]="_isNetworkPage"
    ></ddc-button-n-one>

    <!-- Create -->
    <ddc-button-n-one-action
      class="navbar_network_btn"
      [_icon]="'add'"
      [_label]="'Create'"
      [_themeMode]="true"
      (click)="openAddDialog()"
    ></ddc-button-n-one-action>
  </div>
  <!-- Spacer -->
  <div class="spacer"></div>
  <!-- Ask Lingo AI -->
  <ddc-button-ai
    class="ddc-ai-btn-with-text"
    style="margin-right: 5px"
    [_icon]="'auto_stories'"
    [_label]="'Ask Lingo AI'"
  ></ddc-button-ai>
  <!-- Hints -->
  <div class="hints-container" (click)="openHintsOverlay()">
    <mat-icon class="hints-icon" matTooltip="Hints">lightbulb</mat-icon>
  </div>
  <!-- Notification Bell -->
  <div
    class="notification-bell-container"
    [matMenuTriggerFor]="notificationMenu"
    (menuClosed)="onNotificationMenuClosed()"
    (menuOpened)="onNotificationMenuOpened()"
  >
    <mat-icon class="notification-bell-icon" matTooltip="Notifications">notifications</mat-icon>
    <span
      class="notification-dot"
      *ngIf="_hasNotifications()"
      [ngClass]="{
        'dot-light': _theme === 'light-theme',
        'dot-dark': _theme === 'dark-theme',
        'dot-paper': _theme === 'paper-theme',
      }"
    ></span>
  </div>
  <mat-chip-listbox class="theme-chip-listbox" aria-label="Theme selection">
    <mat-chip-option
      matTooltip="Light Mode"
      selected
      [selected]="_theme === 'light-theme'"
      [value]="_theme"
      (click)="onThemeChipChange('light-theme')"
    >
      <mat-icon>light_mode</mat-icon>
    </mat-chip-option>
    <mat-chip-option
      matTooltip="Dark Mode"
      [selected]="_theme === 'dark-theme'"
      [value]="_theme"
      (click)="onThemeChipChange('dark-theme')"
    >
      <mat-icon>dark_mode</mat-icon>
    </mat-chip-option>
    <mat-chip-option
      matTooltip="Paper Mode"
      [selected]="_theme === 'paper-theme'"
      [value]="_theme"
      (click)="onThemeChipChange('paper-theme')"
    >
      <mat-icon>visibility</mat-icon>
    </mat-chip-option>
  </mat-chip-listbox>
  <!-- Notification Menu -->
  <mat-menu #notificationMenu="matMenu" class="notification-menu" xPosition="before" yPosition="below">
    <div class="notification-header" (click)="$event.stopPropagation()">
      <span class="notification-title">Notifications</span>
    </div>

    <mat-divider></mat-divider>

    <div class="notification-list" *ngIf="_recentNotifications.length > 0; else noNotifications">
      <ng-container *ngFor="let notification of _recentNotifications">
        <ddc-notification-content
          [currentUsername]="_username"
          [getNotificationIcon]="getNotificationIcon"
          [getNotificationMessage]="getNotificationMessage"
          [notification]="notification"
          [type]="notification.type"
        ></ddc-notification-content>
      </ng-container>
    </div>

    <ng-template #noNotifications>
      <div class="no-notifications" (click)="$event.stopPropagation()">
        <mat-icon>notifications_none</mat-icon>
        <span>No notifications yet</span>
      </div>
    </ng-template>

    <mat-divider *ngIf="_recentNotifications.length > 0"></mat-divider>

    <button class="view-all-btn" mat-menu-item [routerLink]="['/notifications']">
      <mat-icon>visibility</mat-icon>
      <span>View All Notifications</span>
    </button>
  </mat-menu>
  <!----- Secondary buttons ------>
  <div class="secondary-buttons" *ngIf="!_isSignupPage && !_isLoginPage && !_isVerificationPage">
    <button class="user-profile-button" matTooltip="Profile" [matMenuTriggerFor]="beforeMenu">
      <div class="user-profile-picture">
        <img
          class="user-pic-rounded"
          *ngIf="!_isProfilePicLoading && _hasPic"
          alt="Profile Picture"
          [src]="_userProfilePic"
        />
        <img
          class="user-pic-rounded"
          *ngIf="_isProfilePicLoading || !_hasPic"
          alt="Default Profile Picture"
          [src]="_DefaultProfilePic"
        />
      </div>
    </button>
    <!-- Account/Setting -->
    <mat-menu #beforeMenu="matMenu" class="account-menu" xPosition="before" yPosition="below">
      <button class="margin-right-10" mat-menu-item [routerLink]="['/users', _username]">
        <mat-icon>account_circle</mat-icon>
        <span class="setting-text-font">View Profile</span>
      </button>
      <button class="margin-right-10" mat-menu-item [routerLink]="['/saved']">
        <mat-icon>bookmark_border</mat-icon>
        <span class="setting-text-font">Bookmarks</span>
      </button>
      <!-- <button
        class="margin-right-10"
        *ngIf="_subscription != 'Free Tier'"
        mat-menu-item
        routerLinkActive="router-link-active"
        [routerLink]="['/flash-cards']"
      >
        <mat-icon
          [ngClass]="{
            'ddc-play-icon-gradient-light': _theme === 'light-theme',
            'ddc-play-icon-gradient-dark': _theme === 'dark-theme',
            'ddc-play-icon-gradient-paper': _theme === 'paper-theme',
          }"
          >style</mat-icon
        >
        <span class="setting-text-font">Flash Cards</span>
      </button> -->
      <button class="margin-right-10" mat-menu-item routerLinkActive="router-link-active" [routerLink]="['/pricing']">
        <mat-icon
          [ngClass]="{
            'ddc-play-icon-gradient-light': _theme === 'light-theme',
            'ddc-play-icon-gradient-dark': _theme === 'dark-theme',
            'ddc-play-icon-gradient-paper': _theme === 'paper-theme',
          }"
          >workspace_premium</mat-icon
        >
        <span class="setting-text-font">Upgrade</span>
      </button>
      <button class="margin-right-10" mat-menu-item routerLinkActive="router-link-active" [routerLink]="['/settings']">
        <mat-icon>settings</mat-icon>
        <span class="setting-text-font">Settings</span>
      </button>
      <button
        class="margin-right-10"
        *ngIf="_isAdmin"
        mat-menu-item
        routerLinkActive="router-link-active"
        [ngClass]="{ adminNavbar: _isAdmin }"
        [routerLink]="['/admin']"
      >
        <mat-icon>admin_panel_settings</mat-icon>
        <span class="setting-text-font">Admin Panel</span>
      </button>
      <mat-divider></mat-divider>
      <!-- ! Extra Begin -->
      <button
        class="margin-right-10 extra-sec-btn"
        mat-menu-item
        routerLinkActive="router-link-active"
        [routerLink]="['/store']"
      >
        <mat-icon>shopping_bag</mat-icon>
        <span class="setting-text-font">Store</span>
      </button>
      <button
        class="margin-right-10 extra-sec-btn"
        mat-menu-item
        routerLinkActive="router-link-active"
        [routerLink]="['/library']"
      >
        <mat-icon>apps</mat-icon>
        <span class="setting-text-font">Library</span>
      </button>
      <button
        class="margin-right-10 extra-sec-btn"
        mat-menu-item
        routerLinkActive="router-link-active"
        [routerLink]="['/network']"
      >
        <mat-icon>people_outline</mat-icon>
        <span class="setting-text-font">Network</span>
      </button>
      <button
        class="margin-right-10 extra-sec-btn"
        *ngIf="_subscription != 'Free Tier'"
        mat-menu-item
        routerLinkActive="router-link-active"
        [routerLink]="['/play']"
      >
        <mat-icon>sports_esports</mat-icon>
        <span>Games</span>
      </button>
      <mat-divider class="extra-sec-btn"></mat-divider>
      <!-- ! Extra End -->

      <button class="margin-right-10 sign-out-btn" mat-menu-item (click)="openLogOutDialog()">
        <mat-icon class="sign-out-btn-icon">account_circle</mat-icon>
        <span class="setting-text-font">Sign Out</span>
      </button>
    </mat-menu>
  </div>
</mat-toolbar>
<!-- <mat-progress-bar mode="indeterminate" class="navbar-progress-bar"></mat-progress-bar> -->
<mat-progress-bar class="navbar-progress-bar" value="100" [mode]="_progressBarMode"></mat-progress-bar>
<!-- <ddc-speed-dial class="speed-dial-container"></ddc-speed-dial> -->
